module.exports = __webpack_public_path__ + "img/ticket.bd7df9fe.png";